var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-app-container",attrs:{"id":"app"}},[_c('Header'),_c('Navigation'),_c('router-view'),_c('Footer'),(_vm.showModal)?_c('Modal',{attrs:{"displayInfo":_vm.modalInfo}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }